import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / plus normal`. Do not edit by hand. */
export function PlusIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M9,9L9,15C9,15.55,8.55,16,8,16L8,16C7.45,16,7,15.55,7,15L7,9L1,9C0.45,9,0,8.55,0,8L0,8C0,7.45,0.45,7,1,7L7,7L7,1C7,0.45,7.45,0,8,0L8,0C8.55,0,9,0.45,9,1L9,7L15,7C15.55,7,16,7.45,16,8L16,8C16,8.55,15.55,9,15,9L9,9" />
    </svg>
  )
}
